/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_LedgerInputs */

const cs_billing_ledger = /** @type {(inputs: Billing_LedgerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pohyby`)
};

const en_billing_ledger = /** @type {(inputs: Billing_LedgerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ledger`)
};

/**
* | output |
* | --- |
* | "Ledger" |
*
* @param {Billing_LedgerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const billing_ledger = /** @type {((inputs?: Billing_LedgerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_LedgerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_billing_ledger(inputs)
	return cs_billing_ledger(inputs)
});